import styled from '@emotion/styled';
import { createElement, FC, lazy, Suspense } from 'react';

const _SignInForm = lazy(() => import('../component/compound/SignInForm'));

interface Props {
  kaizenIdUrl: string;
  kaizenIdWithRedirectUrl: string;
  className?: string;
}

const SignedOutScreen: FC<Props> = ({ kaizenIdUrl, kaizenIdWithRedirectUrl, className }) => (
  <Root className={className}>
    <VideoContainer>
      <Video src="/assets/sign_in_background.mp4" autoPlay loop playsInline muted />
    </VideoContainer>

    <Suspense fallback={<div />}>
      <SignInForm kaizenIdUrl={kaizenIdUrl} kaizenIdWithRedirectUrl={kaizenIdWithRedirectUrl} />
    </Suspense>
  </Root>
);

const Root = styled('div')({
  position: 'relative',
});

const SignInForm = styled(_SignInForm)({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  zIndex: 2,
});

const VideoContainer = styled('div')({
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  zIndex: 1,
  overflow: 'hidden',
});

const Video = styled('video')({
  position: 'absolute',
  top: '50%',
  left: '50%',
  minWidth: '100%',
  minHeight: '100%',
  width: 'auto',
  height: 'auto',
  transform: 'translate(-50%, -50%)',
});

export default SignedOutScreen;
